import { api } from './client'

export type DomainStatus = 'none' | 'pending' | 'verified' | 'failed'

export interface DkimRecord {
  type: string
  host: string
  value: string
  /** The provider's per-record check result (true once this record resolves correctly). */
  valid?: boolean
}

export interface SendingDomain {
  domain: string | null
  status: DomainStatus
  dnsRecords: DkimRecord[]
}

export async function getSendingDomain(): Promise<SendingDomain> {
  const { data } = await api.get<SendingDomain>('/api/settings/sending-domain')
  return data
}

export async function setSendingDomain(domain: string): Promise<SendingDomain> {
  const { data } = await api.put<SendingDomain>('/api/settings/sending-domain', { domain })
  return data
}

export async function verifySendingDomain(): Promise<SendingDomain> {
  const { data } = await api.post<SendingDomain>('/api/settings/sending-domain/verify')
  return data
}

export async function removeSendingDomain(): Promise<SendingDomain> {
  const { data } = await api.delete<SendingDomain>('/api/settings/sending-domain')
  return data
}
